var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-runtime-template',{attrs:{"template":_vm.template},on:{"click":_vm.clicked}})
}
var staticRenderFns = []

export { render, staticRenderFns }